import React, { useRef, useEffect, useState } from "react";
import Grid from "@mui/material/Grid";
import MDButton from "components/MDButton";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Header from "layouts/authentication/components/Header";
import { useMsal } from "@azure/msal-react";

const projectPDFs = {
  ShenAdmin: [
    "/flowCharts/Shen/SHN-SLD-PRO-CHT-00001-00%2C%20SSLD%20Response%20Flow%20Charts%2C%20Sheets%201-5.pdf",
  ],

  Shen: [
    "/flowCharts/Shen/SHN-SLD-PRO-CHT-00001-00%2C%20SSLD%20Response%20Flow%20Charts%2C%20Sheets%201-5.pdf",
  ],

  ShenREG: [
    "/flowCharts/Shen/SHN-SLD-PRO-CHT-00001-00%2C%20SSLD%20Response%20Flow%20Charts%2C%20Sheets%201-5.pdf",
  ],

  // ADVANCED ROLES - Map ADV roles to existing PDFs
  ShenADV: [
    "/flowCharts/Shen/SHN-SLD-PRO-CHT-00001-00%2C%20SSLD%20Response%20Flow%20Charts%2C%20Sheets%201-5.pdf",
  ],
};

function EventResponseFlowChart() {
  const iframeRef = useRef(null);
  const { instance } = useMsal();
  const activeAccount = instance.getActiveAccount();
  const userRoles = activeAccount?.idTokenClaims?.roles || [];

  // Ensure role is retrieved from localStorage or default to first role
  const [selectedRole, setSelectedRole] = useState(
    localStorage.getItem("selectedRole") || userRoles[0] || ""
  );

  useEffect(() => {
    const storedRole = localStorage.getItem("selectedRole");
    if (storedRole && selectedRole !== storedRole) {
      setSelectedRole(storedRole);
    }
  }, []);

  // Check if the selected role exists in projectPDFs; if not, check for corresponding ADV role
  const availableLinks = projectPDFs[selectedRole] || [];

  const toggleFullScreen = () => {
    if (!document.fullscreenElement) {
      iframeRef.current.requestFullscreen().catch((err) => {
        alert(`Error attempting to enable full-screen mode: ${err.message} (${err.name})`);
      });
    } else {
      document.exitFullscreen();
    }
  };

  return (
    <DashboardLayout>
      <Header title="Event Response Flowchart" />
      <Grid container alignItems="center" justifyContent="space-between">
        <Grid item xs={true}>
          <DashboardNavbar />
        </Grid>
        <Grid item sx={{ marginTop: "2rem" }}>
          <MDButton color="info" onClick={toggleFullScreen}>
            Toggle Full Screen
          </MDButton>
        </Grid>
      </Grid>

      {availableLinks.length > 0 ? (
        availableLinks.map((link, index) => (
          <div key={index} style={{ position: "relative", paddingTop: "56.25%" }}>
            <iframe
              ref={iframeRef}
              title={`FlowChart ${index + 1}`}
              src={link}
              style={{
                position: "absolute",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
                border: "none",
              }}
            />
          </div>
        ))
      ) : (
        <p style={{ textAlign: "center", fontSize: "20px", fontWeight: "bold" }}>
          No PDFs Available for Your Selected Role
        </p>
      )}
    </DashboardLayout>
  );
}

export default EventResponseFlowChart;
